/**
 * Most browsers treat setTimeout(..., 0) as "put this function at the end of the async queue." Safari treats it as
 * "do it now," which defeats the whole point. A 10ms timeout successfully puts it at the end of the async queue in
 * every browser.
 */
export const END_OF_BROWSER_ASYNC_QUEUE = 10;
